<a class="card-dep card-equal" (click)="goTo()">
  <div class="bg-travel" [ngStyle]="{
      'background-image':
        'url(' + (travel | travelImagePipe | imagePipe: 'travel' : 'md') + ')',
    }">
    @if (
    travel.pricing_mode === 1
    ? (travel.price_room | currency: travel.currency : "symbol" : ".0-0")
    : (cheapestPackagePrice | currency: travel.currency : "symbol" : ".0-0")
    ) {
    <div class="price">
      <span>
        <small class="text-xs">Da </small>
        {{
        travel.pricing_mode === 1
        ? (travel.price_room
        | currency: travel.currency : "symbol" : ".0-0")
        : (cheapestPackagePrice
        | currency: travel.currency : "symbol" : ".0-0")
        }}</span>
    </div>
    }
    @if (travel.visibility.id === 4) {
    <div class="private-badge">Viaggio privato</div>
    }
  </div>

  <div class="travel-card" [ngClass]="travel | travelStatus">
    @if ((travel | travelStatus) !== "future") {
    <div class="badge" [ngClass]="{
          'badge-ongoing': (travel | travelStatus) === 'ongoing',
          'badge-past': (travel | travelStatus) === 'past',
        }">
      {{
      (travel | travelStatus) === "ongoing"
      ? "Viaggio in corso"
      : "Viaggio concluso"
      }}
    </div>
    }

    <div class="card-content">
      <div class="info">
        <div class="flex align-items-center gap-3 mb-3">
          <h3 class="m-0">
            {{
            travel.name.length > 19
            ? (travel.name | slice: 0 : 19 | titlecase) + "..."
            : (travel.name | titlecase)
            }}
          </h3>
          @if (travel.funding) {
          <strong>(GMG)</strong>
          }
        </div>
        <div class="flex align-items-center gap-3 mb-3">
          <img src="/assets/media/icons/map.png" />
          @for (c of travel.countries; track $index) {
          <div class="flex align-items-center gap-1">
            <small>{{ c.country.name }}</small>
          </div>
          }
        </div>
        <div class="flex align-items-center gap-4">
          <div class="flex align-items-center gap-1 mb-3">
            @for (c of travel.categories | slice: 0 : 3; track $index) {
            @if (travel.categories.length === 1) {
            <div class="flex align-items-center gap-3">
              <img [src]="c.category.id | travelType" height="24" />
              <small>{{ c.category.name }}</small>
            </div>
            } @else {
            <div class="flex align-items-center gap-3 mr-2" [pTooltip]="c.category.name" tooltipPosition="top">
              <img [src]="c.category.id | travelType" height="24" />
            </div>
            }
            }
            @if (travel.categories.length > 3) {
            <small>...</small>
            }
          </div>
        </div>
        @if (dates.length !== 0) {
        <div class="flex align-items-center gap-3 mb-3">
          <img src="/assets/media/icons/back-in-time.png" />
          <small>{{ dates | daysAndNights }}</small>
        </div>
        <div class="flex align-items-center gap-3">
          <img src="/assets/media/icons/departures.png" />
          <small>{{ travel.from_date | date: "dd MMMM yyyy" }}</small>
        </div>
        }
        @if (travel.undisclosed_members_list === false) {
        <div class="flex align-items-center gap-2 mt-2">
          <small>Partecipanti</small>
          @if (travel.availability?.booked! > 0) {
          <p-avatarGroup>
            @for (a of travel.availability?.summary; track $index) {
            <p-avatar [image]="a.profile_picture | imagePipe: 'user-w' : 'sm'" shape="circle"
              [pTooltip]="a.name"></p-avatar>
            }
            @if (travel.availability?.more != 0) {
            <p-avatar [label]="'+' + travel.availability?.more" shape="circle" [style]="{
                      'background-color': '#3c4e58',
                      color: '#ffffff',
                    }"></p-avatar>
            }
          </p-avatarGroup>
          } @else {
          <small class="grey-text pad-small">Nessun traveler presente.</small>
          }
        </div>
        } @else {
        <div class="flex align-items-center gap-2">
          <small>Partecipanti</small>
          <small class="grey-text pad-small">Lista privata.</small>
        </div>
        }

        @if (travel.booking_deadline) {
        @if (travel.booking_deadline | bookingExpired) {
        <div class="flex align-items-center gap-3 mt-3">
          <small class="not-bookable font-medium">
            <strong>Prenotazioni chiuse per questo viaggio</strong>
          </small>
        </div>
        } @else {
        <div class="flex align-items-center gap-3 mt-3">
          <img src="/assets/media/icons/bell-o.png" />
          <small class="yellow font-medium">
            Puoi prenotare fino al
            <strong>{{
              travel.booking_deadline | date: "dd MMMM yyyy"
              }}</strong>
          </small>
        </div>
        }
        }
      </div>
    </div>
  </div>

  <div class="organization-info fixed-height">
    @if (
    (travel.player && !this.travel.assignment) ||
    (travel.player &&
    this.travel.assignment &&
    this.travel.assignment.status.id === enumAssignmentStatus.PENDING) ||
    (travel.player &&
    this.travel.assignment &&
    this.travel.assignment.status.id === enumAssignmentStatus.REJECTED) ||
    (travel.player &&
    this.travel.assignment &&
    this.travel.assignment.status.id === enumAssignmentStatus.REVOKED)
    ) {
    <div class="mb-2 flex align-items-center gap-3">
      <p-avatar [image]="travel.player.logo | imagePipe: 'registry' : 'sm'" shape="circle"></p-avatar>
      <div class="flex flex-column gap-2">
        <small>Offerto da: <br />
          <strong class="clickable" (click)="goTo()">{{
            travel.player.name
            }}</strong>
        </small>
      </div>
    </div>
    }
    @if (
    this.travel.assignment &&
    this.travel.assignment.status.id === enumAssignmentStatus.ACCEPTED
    ) {
    <div class="mb-2 flex align-items-center gap-3">
      <p-avatar shape="circle" [image]="
            travel.assignment.target_user.profile_picture
              | imagePipe: 'user' : 'sm'
          "></p-avatar>
      <div class="flex flex-column gap-2" [routerLink]="[
            '/user/profile',
            travel.assignment.target_user.username,
          ]">
        <small>Tour Leader: <br />
          <strong class="clickable">{{ travel.assignment.target_user.name }}
            {{ travel.assignment.target_user.last_name }}</strong>
        </small>
      </div>
    </div>
    }
    @if (!travel.assignment) {
    <div class="flex align-items-center gap-3">
      <p-avatar [image]="
            travel.related_user.profile_picture | imagePipe: 'user' : 'sm'
          " shape="circle"></p-avatar>
      <div class="flex flex-column gap-2" [routerLink]="['/user/profile', travel.related_user.username]">
        <small>Tour Leader: <br />
          @if (travel.related_user.name) {
          <strong class="clickable">{{ travel.related_user.name }}
            {{ travel.related_user.last_name }}</strong>
          } @else {
          <strong class="clickable">{{
            travel.related_user.username
            }}</strong>
          }
        </small>
      </div>
    </div>
    }
  </div>
</a>

<!-- //card senza blur da eliminare se ok il blur -->
<!-- <div class="info">
    <div class="flex align-items-center gap-3 mb-3">
      <h3 class="m-0">
        {{
          travel.name.length > 19
            ? (travel.name | slice: 0 : 19 | titlecase) + "..."
            : (travel.name | titlecase)
        }}
      </h3>
      @if (travel.funding) {
        <strong>(GMG)</strong>
      }
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <img src="/assets/media/icons/map.png" />
      @for (c of travel.countries; track $index) {
        <div class="flex align-items-center gap-1">
          <small>{{ c.country.name }}</small>
        </div>
      }
    </div>
    <div class="flex align-items-center gap-4">
      <div class="flex align-items-center gap-1 mb-3">
        @for (c of travel.categories | slice: 0 : 3; track $index) {
          @if (travel.categories.length === 1) {
            <div class="flex align-items-center gap-3">
              <img [src]="c.category.id | travelType" height="24" />
              <small>{{ c.category.name }}</small>
            </div>
          } @else {
            <div
              class="flex align-items-center gap-3 mr-2"
              [pTooltip]="c.category.name"
              tooltipPosition="top"
            >
              <img [src]="c.category.id | travelType" height="24" />
            </div>
          }
        }
        @if (travel.categories.length > 3) {
          <small>...</small>
        }
      </div>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <img src="/assets/media/icons/back-in-time.png" />
      <small>{{ dates | daysAndNights }}</small>
    </div>
    <div class="flex align-items-center gap-3">
      <img src="/assets/media/icons/departures.png" />
      <small>{{ travel.from_date | date: "dd MMMM yyyy" }}</small>
    </div>
  
    @if (travel.booking_deadline) {
      @if (travel.booking_deadline | bookingExpired) {
        <div class="flex align-items-center gap-3 mt-3">
          <small class="not-bookable font-medium">
            <strong>Prenotazioni chiuse per questo viaggio</strong>
          </small>
        </div>
      } @else {
        <div class="flex align-items-center gap-3 mt-3">
          <img src="/assets/media/icons/bell-o.png" />
          <small class="yellow font-medium">
            Puoi prenotare fino al
            <strong>{{
              travel.booking_deadline | date: "dd MMMM yyyy"
            }}</strong>
          </small>
        </div>
      }
    }
  </div>
  <div class="organization-info fixed-height">
    @if (
      (travel.player && !this.travel.assignment) ||
      (travel.player &&
        this.travel.assignment &&
        this.travel.assignment.status.id === enumAssignmentStatus.PENDING) ||
      (travel.player &&
        this.travel.assignment &&
        this.travel.assignment.status.id === enumAssignmentStatus.REJECTED) ||
      (travel.player &&
        this.travel.assignment &&
        this.travel.assignment.status.id === enumAssignmentStatus.REVOKED)
    ) {
      <div class="mb-2 flex align-items-center gap-3">
        <p-avatar
          [image]="travel.player.logo | imagePipe: 'registry' : 'sm'"
          shape="circle"
        ></p-avatar>
        <div class="flex flex-column gap-2">
          <small
            >Offerto da: <br />
            <strong class="clickable" (click)="goTo()">{{
              travel.player.name
            }}</strong>
          </small>
        </div>
      </div>
    }
    @if (
      this.travel.assignment &&
      this.travel.assignment.status.id === enumAssignmentStatus.ACCEPTED
    ) {
      <div class="mb-2 flex align-items-center gap-3">
        <p-avatar
          shape="circle"
          [image]="
            travel.assignment.target_user.profile_picture
              | imagePipe: 'user' : 'sm'
          "
        ></p-avatar>
        <div
          class="flex flex-column gap-2"
          [routerLink]="[
            '/user/profile',
            travel.assignment.target_user.username,
          ]"
        >
          <small
            >Tour Leader: <br />
            <strong class="clickable"
              >{{ travel.assignment.target_user.name }}
              {{ travel.assignment.target_user.last_name }}</strong
            >
          </small>
        </div>
      </div>
    }
    @if (!travel.assignment) {
      <div class="flex align-items-center gap-3">
        <p-avatar
          [image]="
            travel.related_user.profile_picture | imagePipe: 'user' : 'sm'
          "
          shape="circle"
        ></p-avatar>
        <div
          class="flex flex-column gap-2"
          [routerLink]="['/user/profile', travel.related_user.username]"
        >
          <small
            >Tour Leader: <br />
            @if (travel.related_user.name) {
              <strong class="clickable"
                >{{ travel.related_user.name }}
                {{ travel.related_user.last_name }}</strong
              >
            } @else {
              <strong class="clickable">{{
                travel.related_user.username
              }}</strong>
            }
          </small>
        </div>
      </div>
    }
  </div> -->